import { ChevronDown } from "lucide-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import IconDelete from "@/assets/icons/delete.svg?react";
import IconEdit from "@/assets/icons/edit.svg?react";
import AccordionTable from "@/components/admin/displayGroup/AccordionTable";
import Button from "@/components/ui/Button";
import { routes } from "@/configs/router.config/routes";
import { cn } from "@/lib/utils";
import { DisplayGroup } from "@/models/displayGroup";

interface DisplayGroupItemProps {
  displayGroup: DisplayGroup;
  accordionData: Record<string, { groups: string[]; versions: string[]; }>;
  currentWorkspaceId: string;
  onDelete: (id: string) => void;
}

const DisplayGroupItem: React.FC<DisplayGroupItemProps> = ({
  displayGroup,
  accordionData,
  currentWorkspaceId,
  onDelete,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      {/* ヘッダー部分（折りたたみ状態） */}
      <div
        className={cn(
          "flex items-center justify-between px-6 py-3",
          "bg-gradient-to-b from-white to-[#e5e5e5] border border-[#b7b7b7] rounded-[5px] cursor-pointer",
        )}
        onClick={toggleExpanded}
        onKeyDown={(e) => e.key === " " && toggleExpanded()}
        tabIndex={0}
        role="button"
      >
        <div className="flex items-center gap-2">
          <button
            onClick={toggleExpanded}
            className="flex items-center justify-center w-4 h-4 cursor-pointer"
          >
            {isExpanded
              ? <ChevronDown size={20} className="text-[#333333]" />
              : (
                <div className="rotate-[270deg]">
                  <ChevronDown size={20} className="text-[#333333]" />
                </div>
              )}
          </button>
          <span className="text-[18px] font-bold text-[#333333] text-center">
            {displayGroup.name}
          </span>
        </div>
        <div className="flex gap-2">
          <Link to={routes.displayGroupEdit(currentWorkspaceId)(displayGroup.id)}>
            <Button
              className={cn(
                "w-30 h-7.5 gap-[3px] !text-sm text-white !font-bold",
                "bg-[#6888e1] border-[#6888e1] hover:bg-[#6888e1]/90 shadow-[0px_2px_#3c569d]",
              )}
            >
              <IconEdit className="scale-70" />
              編集
            </Button>
          </Link>
          <Button
            className={cn(
              "w-30 h-7.5 gap-1 !text-sm text-white !font-bold",
              "bg-[#ff6b6b] border-[#ff6b6b] hover:bg-[#ff6b6b]/90 shadow-[0px_2px_#9b3c44]",
            )}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(displayGroup.id);
            }}
          >
            <IconDelete className="scale-80" />
            削除
          </Button>
        </div>
      </div>

      {/* 展開時のAccordionTable */}
      {isExpanded && (
        <div className="">
          <AccordionTable
            data={accordionData}
            selectedPaths={[]}
            onSelectionChange={() => {}} // 読み取り専用なので空の関数
            emptyMessage="このグループに割り当てられているカテゴリはありません"
            mode="group"
          />
        </div>
      )}
    </div>
  );
};

export default DisplayGroupItem;
